import styled from 'styled-components';

type Props = {};

export default styled.section<Props>`
  .box-button {
    display: flex;
    justify-content: center;
    flex-direction: column;
    align-items: center;
  }
`;
